/**
 * CAPTION IT — Hero floating cards animation
 * Vanilla JS. Respects prefers-reduced-motion and switches to a
 * compact 3-card mobile layout below 640px.
 */
(function () {
  'use strict';

  /* Desktop: 5 cards spread around. Mobile: 3 cards centered. */
  const DESKTOP_LAYOUTS = [
    { x: -260, y: -40, r: -14, scale: 0.85, drift: { x: 8, y: 6, freq: 1.0, phase: 0 } },
    { x:   80, y: -90, r:   8, scale: 0.95, drift: { x: 6, y: 9, freq: 0.7, phase: 1 } },
    { x:  340, y:  20, r:  -6, scale: 0.80, drift: { x: 10, y: 5, freq: 0.9, phase: 2 } },
    { x: -180, y: 130, r:  12, scale: 0.78, drift: { x: 7,  y: 8, freq: 1.1, phase: 3 } },
    { x:  180, y: 160, r: -10, scale: 0.82, drift: { x: 9,  y: 6, freq: 0.85, phase: 4 } },
  ];

  const MOBILE_LAYOUTS = [
    { x: -70, y:  10, r: -10, scale: 0.55, drift: { x: 4, y: 4, freq: 0.9, phase: 0 } },
    { x:   8, y: -16, r:   4, scale: 0.62, drift: { x: 3, y: 5, freq: 0.7, phase: 1 } },
    { x:  82, y:  18, r:  -4, scale: 0.55, drift: { x: 4, y: 3, freq: 0.85, phase: 2 } },
  ];

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobileMQ = window.matchMedia('(max-width: 640px)');

  class HeroCards {
    constructor(container) {
      this.container = container;
      this.cards = Array.from(container.querySelectorAll('.ci-hero-card'));
      this.tick = 0;
      this.raf = null;
      this.layouts = this.pickLayouts();
      this.applyVisibility();
      this.snapStatic();
      this.bindMQ();
      if (this.cards.length === 0) return;
      if (!reduceMotion.matches) this.start();
    }

    pickLayouts() {
      return mobileMQ.matches ? MOBILE_LAYOUTS : DESKTOP_LAYOUTS;
    }

    applyVisibility() {
      /* Hide extra cards on mobile (we only animate 3) */
      const limit = this.layouts.length;
      this.cards.forEach((el, i) => {
        el.style.display = i < limit ? '' : 'none';
      });
    }

    /* Place cards in their base position without animation
       (used when reduce-motion or before RAF starts) */
    snapStatic() {
      this.cards.forEach((el, i) => {
        const l = this.layouts[i];
        if (!l) return;
        el.style.transform = `translate(calc(-50% + ${l.x}px), calc(-50% + ${l.y}px)) rotate(${l.r}deg) scale(${l.scale})`;
      });
    }

    bindMQ() {
      const onMQ = () => {
        this.layouts = this.pickLayouts();
        this.applyVisibility();
        if (reduceMotion.matches) this.snapStatic();
      };
      mobileMQ.addEventListener('change', onMQ);
      reduceMotion.addEventListener('change', () => {
        if (reduceMotion.matches) {
          this.stop();
          this.snapStatic();
        } else {
          this.start();
        }
      });
    }

    animate() {
      this.tick += 0.016;
      this.cards.forEach((el, i) => {
        const l = this.layouts[i];
        if (!l) return;
        const t = this.tick * l.drift.freq + l.drift.phase;
        const dx = Math.sin(t) * l.drift.x;
        const dy = Math.cos(t * 0.9) * l.drift.y;
        const rot = l.r + Math.sin(t * 0.7) * 1.5;
        el.style.transform = `translate(calc(-50% + ${l.x + dx}px), calc(-50% + ${l.y + dy}px)) rotate(${rot}deg) scale(${l.scale})`;
      });
      this.raf = requestAnimationFrame(() => this.animate());
    }

    start() {
      if (this.raf || reduceMotion.matches) return;
      this.raf = requestAnimationFrame(() => this.animate());
    }
    stop() {
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = null;
    }
  }

  function initHero() {
    const container = document.querySelector('.ci-hero__cards');
    if (!container) return;

    const instance = new HeroCards(container);

    /* Pause animation when section is off screen for perf */
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) instance.start();
        else instance.stop();
      });
    }, { threshold: 0.1 });
    obs.observe(container);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHero);
  } else {
    initHero();
  }
})();

/* ──────────────────────────────────────────────────────────────────
   Hero name scramble — rotazione nomi nelle carte con effetto
   "lettere che diventano altre lettere" (decrypt/glitch style).
   ────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  const NAMES = ['MARCO', 'GIULIA', 'FRANCO', 'SARA', 'LUCA', 'ELENA', 'ANNA', 'PAOLO'];
  const ROTATE_EVERY_MS = 3500;
  const SCRAMBLE_DURATION_MS = 700;
  const SCRAMBLE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

  function $$ (sel) { return Array.from(document.querySelectorAll(sel)); }

  function randChar() { return SCRAMBLE_CHARS[Math.floor(Math.random() * SCRAMBLE_CHARS.length)]; }

  function scrambleTo(el, target) {
    const len = target.length;
    const startT = performance.now();
    /* Settle time per each letter, progressively (revealed left-to-right) */
    const settleAt = Array.from({ length: len }, (_, i) => 100 + i * 80);

    function frame(t) {
      const elapsed = t - startT;
      let out = '';
      let allSettled = true;
      for (let i = 0; i < len; i++) {
        if (elapsed >= settleAt[i]) {
          out += target[i];
        } else {
          /* Mantieni spazi e punteggiatura intatti — scramble solo lettere */
          out += /[A-Z]/i.test(target[i]) ? randChar() : target[i];
          allSettled = false;
        }
      }
      el.textContent = out;
      if (!allSettled && elapsed < SCRAMBLE_DURATION_MS) {
        requestAnimationFrame(frame);
      } else {
        el.textContent = target;
      }
    }
    requestAnimationFrame(frame);
  }

  function init() {
    const els = $$('[data-ci-hero-name]');
    if (!els.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let idx = 0;
    setInterval(() => {
      idx = (idx + 1) % NAMES.length;
      const next = NAMES[idx];
      els.forEach(el => scrambleTo(el, next));
    }, ROTATE_EVERY_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
